import { render, staticRenderFns } from "./StorageInfo.vue?vue&type=template&id=028dc850&scoped=true&"
import script from "./StorageInfo.vue?vue&type=script&lang=ts&"
export * from "./StorageInfo.vue?vue&type=script&lang=ts&"
import style0 from "./StorageInfo.vue?vue&type=style&index=0&id=028dc850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028dc850",
  null
  
)

export default component.exports